
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bVayQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $67e02f418b40c681$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $930aefdeeed5acd0$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': 'Aggrega dati',
    'extension.charts.aggregateDataDescription': "Combina i valori in un unico punto dati quando pi\xf9 righe presentano lo stesso valore.",
    'extension.charts.category': 'Categoria',
    'extension.charts.customizeTab': 'Personalizza',
    'extension.charts.dataMissing.details': 'Impossibile trovare la tabella di origine di questo grafico nella pagina.',
    'extension.charts.dataMissing.title': 'Nessun dato da visualizzare',
    'extension.charts.dataTab': 'Dati',
    'extension.charts.defaultColumnName': 'Colonna {0}',
    'extension.charts.defaultTitle': 'Grafico senza titolo',
    'extension.charts.defaultYLabel': 'Asse senza titolo',
    'extension.charts.extensionTitle': 'Grafico',
    'extension.charts.height': 'Altezza area del tracciato',
    'extension.charts.height.large': "Pi\xf9 alto",
    'extension.charts.height.medium': 'Predefiniti',
    'extension.charts.height.small': "Pi\xf9 basso",
    'extension.charts.horizontal.orientation.label': 'Orizzontale',
    'extension.charts.insert.tooltip': 'Inserisci grafico',
    'extension.charts.legend': 'Legenda',
    'extension.charts.legend.auto': 'Auto',
    'extension.charts.legend.bottom': 'Sotto',
    'extension.charts.legend.left': 'Sinistra',
    'extension.charts.legend.position': 'Posizione legenda',
    'extension.charts.legend.right': 'Destra',
    'extension.charts.legend.show': 'Mostra legenda',
    'extension.charts.legend.top': 'Sopra',
    'extension.charts.options.label': 'Opzioni grafico',
    'extension.charts.options.tooltip': 'Cambia opzioni grafico',
    'extension.charts.orientation.label': 'Orientamento',
    'extension.charts.seriesNames': 'Serie di dati',
    'extension.charts.showPoints': 'Mostra punti dati',
    'extension.charts.smoothLines': 'Linee smussate',
    'extension.charts.style': 'Stile',
    'extension.charts.title': 'Titolo',
    'extension.charts.type.bar': 'A barre',
    'extension.charts.type.fieldDescription': 'Tipo di grafico',
    'extension.charts.type.line': 'A linee',
    'extension.charts.type.pie': 'A torta',
    'extension.charts.userTitle': 'Titolo',
    'extension.charts.vertical.orientation.label': 'Verticale',
    'extension.charts.xAxis': 'Asse X',
    'extension.charts.xLabel': "Etichetta dell'asse X",
    'extension.charts.yLabel': 'Etichetta asse X'
};


var $67e02f418b40c681$export$2e2bcd8739ae039 = (0, $930aefdeeed5acd0$export$2e2bcd8739ae039);

});


//# sourceMappingURL=it.7a2e264a.js.map
